/**
 * @module builder
 */
import type { MoveableItem } from '../../index'

export function filterBid(item: MoveableItem): boolean {
  return item.use_total && !item.additionalWork && !item.pending
}
